import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Iter-263 §post-review: shared error UI for the /jobs/* data pages.
 * Distinguishes real transport/server failures from valid empty data
 * (a defect flagged by iter-86 reviewer).
 */
export default function ErrorState({ onRetry, message }) {
  return (
    <div
      data-testid="jobs-error-state"
      className="mt-6 rounded-2xl border border-amber-200 bg-amber-50 text-amber-800 p-5 flex items-start gap-3"
    >
      <AlertTriangle className="w-5 h-5 mt-0.5" />
      <div className="flex-1">
        <div className="font-semibold">Couldn't load</div>
        <div className="text-sm mt-0.5">
          {message || "Please retry in a moment. If it keeps happening, sign out and back in."}
        </div>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          data-testid="jobs-error-retry"
          className="inline-flex items-center gap-1.5 rounded-full bg-white border border-amber-300 text-amber-800 hover:bg-amber-100 font-semibold px-3 py-1.5 text-sm"
        >
          <RefreshCw className="w-3.5 h-3.5" /> Retry
        </button>
      )}
    </div>
  );
}
